









import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class NumpadButton extends Vue {
  @Prop(String) buttonText!: string;
  @Prop(Number) buttonIndex!: number;
  @Prop({type: Number, default: -1}) currentIndex!: number;
}
